import React from 'react';
import { makeStyles } from '@material-ui/core/styles';
import { CircularProgress } from '@material-ui/core';

const useStyles = makeStyles({
  root: {
    marginTop: '50px',
    marginLeft: '50%',
    color: '#003f63',
  },
});

export default function ComponentOrSpinner(props) {
  const classes = useStyles();

  return (
    props.isLoading
      ? <CircularProgress className={classes.root} />
      : props.children
  );
}
